import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import AppCheckout from '@js/components/checkout/AppCheckout.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/checkout',
    component: AppCheckout,
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.afterEach((to, from) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'pageview',
    page_path: to.fullPath,
    page_location: window.location.href,
    page_title: document.title,
  })
})

export default router
